import {
  BellRing,
  DollarSign,
  Briefcase,
  StickyNote,
  Handshake,
  HandCoins,
  Star,
  Send,
  CircleX,
  TriangleAlert,
} from "lucide-react";

export const getNotificationIcon = (type, iconSize = 20) => {
  switch (type) {
    case "new_opportunity":
    case "request_for_collaboration":
      return <Handshake color="#9CA3AF" size={iconSize} />;
    case "offer_created":
    case "offer_withdrawn":
    case "offer_accepted":
    case "offer_rejected":
    case "offer_expired":
    case "offer_complete_pending":
    case "offer_completed":
    case "offer_cancel_requested":
    case "offer_cancelled":
    case "offer_escalated":
    case "offer_resolved_complete":
    case "offer_resolved_cancelled":
      return <HandCoins color="#9CA3AF" size={iconSize} />;
    case "campaign_complete":
    case "campaign_begins_today":
    case "campaign_post_due_5_days":
    case "campaign_post_due_3_days":
    case "campaign_post_due_tomorrow":
    case "campaign_post_due_today":
    case "campaign_activity_started":
      return <StickyNote color="#9CA3AF" size={iconSize} />;
    case "payment_received":
    case "payment_subscription_failed":
      return <DollarSign color="#9CA3AF" size={iconSize} />;
    case "brand_feedback_review":
    case "influencer_content_review":
      return <Star color="#9CA3AF" size={iconSize} />;
    case "influencer_applied":
    case "application_withdrawn":
      return <Send color="#9CA3AF" size={iconSize} />;
    case "application_rejected":
      return <CircleX color="#9CA3AF" size={iconSize} />;
    case "social_token_expired":
      return <TriangleAlert color="#9CA3AF" size={iconSize} />;
    default:
      return <BellRing color="#9CA3AF" size={iconSize} />;
  }
};
